import { useEffect } from 'react';
import HeaderStyleTwo from '../Shared/HeaderStyleTwo';
import Footer from '../Shared/Footer';
const SmallBusinessProgram = () => {
  useEffect(() => {
    runJQueryScripts();
  }, []);

  const runJQueryScripts = () => {
    let tag: any;
    let loadScript = function (src: string) {
      tag = document.createElement('script');
      tag.async = false;
      tag.src = src;
      document.getElementsByTagName('body')[0].appendChild(tag);
    };
    loadScript('../assets/js/jquery.js');
    loadScript('../assets/js/popper.min.js');
    loadScript('../assets/js/jquery-ui.js');
    loadScript('../assets/js/jquery.fancybox.js');
    loadScript('../assets/js/owl.js');
    loadScript('../assets/js/appear.js');
    loadScript('../assets/js/wow.js');
    loadScript('../assets/js/lazyload.js');
    loadScript('../assets/js/scrollbar.js');
    loadScript('../assets/js/script.js');
    return () => {
      document.getElementsByTagName('body')[0].removeChild(tag);
    };
  };
  return (
    <>
      <HeaderStyleTwo />
      <div className='ulockd-inner-page'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='ulockd-icd-layer'>
                <ul className='list-inline ulockd-icd-sub-menu'>
                  <li>
                    <a style={{ color: '#25283a' }} href='/'>
                      {' '}
                      Home{' '}
                    </a>
                  </li>
                  <li>
                    <a style={{ color: '#25283a' }} href='#'>
                      <b> / </b>
                    </a>
                  </li>
                  <li>
                    {' '}
                    <a href='/helping-an-orphan'>Helping An Orphan </a>{' '}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className='sidebar-page-container'
        style={{ padding: '50px 0px 0px' }}
      >
        <div className='auto-container'>
          <div className='row clearfix'>
            <div className='content-side col-lg-8 col-md-12 col-sm-12'>
              <div className='cause-details'>
                <div className='inner-box'>
                  <div className='image-box'>
                    <figure className='image'>
                      <a href='/get-involved'>
                        <img
                          className='lazy-image'
                          src='assets/images/resource/image-spacer-for-validation.png'
                          data-src='assets/images/blog/sadqajariya.com-helping-an-orphan.webp'
                          alt=''
                        />
                      </a>{' '}
                    </figure>
                  </div>

                  <div
                    className='lower-content'
                    style={{ padding: '40px 0 0' }}
                  >
                    <div className='text-content'>
                      <h2>
                        <a href='/get-involved'>Helping An Orphan</a>
                      </h2>
                      <h3>WHO IS AN ORPHAN?</h3>
                      <p>
                        An orphan is a child whose parents are dead or have
                        abandoned them permanently. In common usage, only a
                        child who has lost both parents due to death is called
                        an orphan.
                      </p>
                      <p>
                        Adults can also be referred to as orphan, or adult
                        orphans. However, survivors who reached adulthood before
                        their parents died are normally not called orphans. It
                        is a term generally reserved for children whose parents
                        have died while they are too young to support
                        themselves.
                      </p>
                      <h3>ISLAM AND ORPHAN</h3>
                      <ul>
                        <li>
                          In Islam, it is the right of a child to be protected,
                          taken care of physically, psychologically and
                          emotionally. And these rights donate change when they
                          become orphans. Prophet Muhammad (peace be upon him)
                          was himself an orphan. There is great importance set
                          in the Quran and Sunnah (the teachings of the Prophet
                          (PBUH)) in the treatment of the orphans.
                        </li>
                        <li>
                          Prophet Mohammad (PBUH) said, "Whoever caresses the
                          head of an orphan (in affection), solely for the sake
                          of Allah, a good deed will be written to his account
                          for every hair over which he passed his hand. –
                          narrated by Abu Huraira.
                        </li>
                        <li>
                          According to Islam, orphans are those children who are
                          left with no protection because their fathers have
                          passed away. Many orphans have no source of income
                          and/or a guardian to take care of them. This is where
                          Muslims as a community have to step in and aid the
                          orphans even if the mother is still living.There is
                          also great responsibility that comes with taking care
                          of orphans. There are very strict guidelines when it
                          comes to Islam and taking care of orphans. And we as
                          Helping Hand for Relief and Development understand and
                          take them seriously.
                        </li>
                        <li>
                          Prophet Mohammad (PBUH) said, "I and the person who
                          looks after an orphan and provides for him, will be in
                          Paradise like this," putting his index and middle
                          fingers together. - Narrated by Sahl bin Sa'd
                        </li>
                        <li>There is great reward in caring for an orphan</li>
                      </ul>
                      <h3>HOW CAN WE HELP?</h3>
                      <p>
                        Donate now to support and distribute monthly food
                        packages to needy and less fortunate families in
                        diffrent cities of pakistan among widows, orphans,
                        senior citizen, destitute, handicapped and needy
                        families those who have been passing their life in a
                        difficult situation just because they do not have any
                        responsible for earning/food. They can hardly manage
                        food for 1 time in a day. Please help the poor, sick,
                        old and destitute peoples, most specifically widows,
                        orphans and senior citizens. In about USD 20 you can
                        feed a family of 5 for a month. We will provide you the
                        details of the destitute families that you will support
                        them.
                      </p>
                      <p>
                        <b>
                          In about $20 you can feed a family of 5 for a month.
                        </b>
                      </p>
                      <br />
                      <p>
                        Invest your money to gain pleasure of <b>ALLAH</b>.
                      </p>
                      <br />
                      <h3>Your help turns into smiles.</h3>
                    </div>
                    <div className='link-box'>
                      <a
                        href='/get-involved'
                        className='theme-btn btn-style-one'
                      >
                        <span className='btn-title'>Donate Now</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='sidebar-side col-lg-4 col-md-12 col-sm-12'>
              <aside className='sidebar'>
                <div className='sidebar-widget categories'>
                  <div className='text'>
                    <b>
                      You can be a part of the change in this world. Give a
                      helping hand to those who need it!
                    </b>
                  </div>
                  <h3 className='sidebar-title'>Our Programs</h3>
                  <div className='widget-content'>
                    <ul>
                      <li className='current'>
                        <a href='/free-grocery-for-widows-and-senior-citizen'>
                          Free Grocery for Widows and Senior Citizen
                        </a>
                      </li>
                      <li>
                        <a href='/apna-rozgar'>
                          Apna Rozgar (Small Business Setups)
                        </a>
                      </li>
                      <li>
                        <a href='/medical-support'>Free Medical Support</a>
                      </li>
                      <li>
                        <a href='/basic-schools'>
                          Free Education for Child (Basic Schools)
                        </a>
                      </li>
                      <li>
                        <a href='/water-hand-pumps'>
                          Clean Water Program (Water Hand Pumps)
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default SmallBusinessProgram;
